/**
 * Обрезает строку до указанной длины и добавляет троеточие, если строка превышает максимальную длину
 * @param str - Исходная строка для обрезки
 * @param maxLength - Максимальная длина строки (по умолчанию 20 символов)
 * @returns Обрезанная строка с троеточием или оригинальная строка, если она короче максимальной длины
 * @example
 * // Возвращает "Это очень длинная стр..."
 * truncateString("Это очень длинная строка которая будет обрезана", 20);
 * 
 * @example
 * // Возвращает "Короткая строка"
 * truncateString("Короткая строка", 20);
 */
function truncateString(str: string, maxLength: number = 20): string {
    if(typeof str !== 'string') return '';
    // Проверяем, что maxLength не меньше 4 (минимум 1 символ + 3 точки)
    const validMaxLength = Math.max(maxLength, 4);
    
    if (str.length > validMaxLength) {
        return str.substring(0, validMaxLength - 3) + '...';
    }
    return str;
}

// Экспорт для использования в модулях
export { truncateString };